import axios from 'axios'

export const getCategories = async (backendUrl: string) => {
    try {
        const response = await axios.get(`${backendUrl}/api/v1/categories`)

        return response.data
    } catch (e) {
        console.log('error', e)
        throw e
    }
}
